// extracted by mini-css-extract-plugin
export var alignBaseline = "_13-9";
export var alignCenter = "_13-5";
export var alignFlexEnd = "_13-7";
export var alignFlexStart = "_13-6";
export var alignSelfBaseline = "_13-e";
export var alignSelfCenter = "_13-a";
export var alignSelfFlexEnd = "_13-c";
export var alignSelfFlexStart = "_13-b";
export var alignSelfStretch = "_13-d";
export var alignStretch = "_13-8";
export var column = "_13-2";
export var columnReverse = "_13-4";
export var flex = "_13-0";
export var justifyCenter = "_13-f";
export var justifyFlexEnd = "_13-h";
export var justifyFlexStart = "_13-g";
export var justifySpaceAround = "_13-j";
export var justifySpaceBetween = "_13-i";
export var justifySpaceEvenly = "_13-k";
export var row = "_13-1";
export var rowReverse = "_13-3";
export var wrapNowrap = "_13-m";
export var wrapWrap = "_13-l";
export var wrapWrapReverse = "_13-n";